// 엔드포인트 URL을 생성하는 함수의 타입을 정의합니다.
export interface BuyerInquiryEndpointsProps {
  get_buyer_inquiry_list: (page: number, size: number) => string; // 문의 이력 조회
  post_buyer_inquiry_to_seller: () => string; // 판매자에게 문의 등록
  get_buyer_inquiry_detail: (inquiryId: string) => string; // 문의 상세 조회
}

// 구매자 문의하기 관련 엔드포인트 정의
export const BuyerInquiryEndpoints: BuyerInquiryEndpointsProps = {
  get_buyer_inquiry_list: (page, size) =>
    `api/buyer/inquiries?page=${page}&size=${size}`, // 문의 이력 조회
  post_buyer_inquiry_to_seller: () => `api/buyer/inquiries`, // 판매자에게 문의 등록
  get_buyer_inquiry_detail: (inquiryId: string) =>
    `api/buyer/inquiries/${inquiryId}`, // 문의 상세 조회
};

export default BuyerInquiryEndpoints;
